import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { removeRuoYiAdminTokenCookie } from '../../api/ruoyiSso'

interface User {
  id: string | number
  username: string
  email: string
  role: string
  roles?: string[]
  avatar?: string
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  permissions: string[]
  roles: string[]
}

// 从localStorage恢复初始状态
const loadAuthFromStorage = (): AuthState => {
  try {
    const token = localStorage.getItem('token')
    const userStr = localStorage.getItem('user')
    const rolesStr = localStorage.getItem('roles')
    
    if (token && userStr) {
      const user = JSON.parse(userStr)
      const roles = rolesStr ? JSON.parse(rolesStr) : []
      return {
        user,
        token,
        isAuthenticated: true,
        permissions: [],
        roles,
      }
    }
  } catch (error) {
    console.error('从localStorage恢复认证状态失败:', error)
  }
  
  return {
    user: null,
    token: null,
    isAuthenticated: false,
    permissions: [],
    roles: [],
  }
}

const initialState: AuthState = loadAuthFromStorage()

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<{ user: User; token: string; permissions?: string[]; roles?: string[] }>) => {
      state.user = action.payload.user
      state.token = action.payload.token
      state.isAuthenticated = true
      if (action.payload.permissions) {
        state.permissions = action.payload.permissions
      }
      if (action.payload.roles) {
        state.roles = action.payload.roles
      }
      
      // 保存到localStorage
      try {
        localStorage.setItem('token', action.payload.token)
        localStorage.setItem('user', JSON.stringify(action.payload.user))
        if (action.payload.roles) {
          localStorage.setItem('roles', JSON.stringify(action.payload.roles))
        }
      } catch (error) {
        console.error('保存认证状态到localStorage失败:', error)
      }
    },
    setPermissions: (state, action: PayloadAction<{ permissions: string[]; roles: string[] }>) => {
      state.permissions = action.payload.permissions
      state.roles = action.payload.roles
    },
    logout: (state) => {
      state.user = null
      state.token = null
      state.isAuthenticated = false
      state.permissions = []
      state.roles = []
      
      // 清除localStorage
      try {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('roles')
      } catch (error) {
        console.error('清除localStorage失败:', error)
      }
      removeRuoYiAdminTokenCookie()
    },
  },
})

export const { setCredentials, setPermissions, logout } = authSlice.actions
export default authSlice.reducer

